<div class="table-wrapper glass-card rounded-2xl mb-6 overflow-hidden">
  <div class="p-6 border-b border-white/10 flex items-center justify-between">
    <h2 class="text-lg font-semibold text-text-primary">Zeiterfassung</h2>
    @if (editable()) {
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="btn-secondary flex justify-center"
          [ngClass]="headerPinned() ? 'text-primary bg-primary/15' : 'text-text-muted hover:text-text-primary hover:bg-white/10'"
          (click)="toggleHeaderPin()"
          [title]="headerPinned() ? 'Kopfzeile lösen' : 'Kopfzeile fixieren'"
        >
          <span class="material-icons text-lg">push_pin</span>
        </button>
        <button type="button" class="btn-primary flex items-center gap-2" [disabled]="isSubmitting()" (click)="addRow()">
          <span class="material-icons text-lg">add</span>
          Zeile hinzufügen
        </button>
      </div>
    }
  </div>

  @if (!saved()) {
    <div class="p-6">
      <p class="text-sm text-text-muted">Bitte erstellen Sie den Auftragsbegleitschein zuerst, um Positionen hinzuzufügen.</p>
    </div>
  } @else if (!hasCustomer()) {
    <div class="p-6">
      <p class="text-sm text-text-muted">Ordnen Sie einen Kunden zu, damit Zeiten erfasst werden können.</p>
    </div>
  } @else {
    @let stickyHeader = headerPinned() ? 'sticky top-0 z-10 bg-[#131b2e]' : '';
    <div [ngClass]="headerPinned() ? 'overflow-auto max-h-[calc(100vh-14rem)] overscroll-contain' : 'overflow-x-auto'">
      <table class="w-full">
        <thead>
          <tr class="border-b border-white/10">
            <th class="px-2 py-3 text-left text-xs font-semibold text-text-secondary whitespace-nowrap" [ngClass]="stickyHeader">Pos. *</th>
            <th class="px-2 py-3 text-left text-xs font-semibold text-text-secondary whitespace-nowrap" [ngClass]="stickyHeader">Datum *</th>
            <th class="px-2 py-3 text-left text-xs font-semibold text-text-secondary whitespace-nowrap" [ngClass]="stickyHeader">Pers.-Nr. *</th>
            <th class="px-2 py-3 text-left text-xs font-semibold text-text-secondary whitespace-nowrap" [ngClass]="stickyHeader">Tätigkeit *</th>
            <th class="px-2 py-3 text-left text-xs font-semibold text-text-secondary whitespace-nowrap" [ngClass]="stickyHeader">Stück</th>
            <th class="px-2 py-3 text-left text-xs font-semibold text-text-secondary whitespace-nowrap" [ngClass]="stickyHeader">Zeit *</th>
            <th class="px-2 py-3 text-left text-xs font-semibold text-text-secondary whitespace-nowrap" [ngClass]="stickyHeader">Bemerkung</th>
            <th class="px-2 py-3 text-left text-xs font-semibold text-text-secondary whitespace-nowrap" [ngClass]="stickyHeader"></th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row; let i = $index) {
            <tr [formGroup]="row" class="position-row border-b border-white/10">
              <!-- Pos. -->
              <td class="p-2 align-middle">
                <input
                  type="number"
                  formControlName="posNr"
                  class="w-full min-w-[48px] h-10 px-3 py-2 rounded-lg bg-white/8 border text-text-primary text-[0.8125rem] truncate transition-all focus:outline-none focus:border-primary read-only:cursor-not-allowed [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-outer-spin-button]:m-0"
                  [ngClass]="isFieldInvalid(row.get('posNr')) ? 'border-red-500 focus:border-red-500' : 'border-white/12'"
                  placeholder="z.B Pos. 1"
                  appSelectOnFocus
                />
              </td>

              <!-- Datum -->
              <td class="p-2 align-middle">
                <p-datepicker
                  formControlName="date"
                  dateFormat="dd.mm.yy"
                  [showIcon]="true"
                  [class.error]="isFieldInvalid(row.get('date'))"
                  appendTo="body"
                  styleClass="datepicker-component-style position-datepicker-style min-w-24"
                  panelStyleClass="datepicker-panel-style"
                ></p-datepicker>
              </td>

              <!-- Pers.-Nr. -->
              <td class="p-2 align-middle">
                <input
                  type="text"
                  formControlName="employeeNumber"
                  class="w-full min-w-[48px] h-10 px-3 py-2 rounded-lg bg-white/8 border text-text-primary text-[0.8125rem] truncate transition-all focus:outline-none focus:border-primary read-only:cursor-not-allowed"
                  [ngClass]="isFieldInvalid(row.get('employeeNumber')) ? 'border-red-500 focus:border-red-500' : 'border-white/12'"
                  appSelectOnFocus
                />
              </td>

              <!-- Tätigkeit -->
              <td class="p-2 align-middle">
                <p-select
                  formControlName="activity"
                  [options]="positionActivityOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Wählen"
                  [filter]="false"
                  [showClear]="false"
                  [class.error]="isFieldInvalid(row.get('activity'))"
                  appendTo="body"
                  styleClass="select-component-style position-select-style"
                  panelStyleClass="select-component-panel-style"
                >
                  <ng-template pTemplate="item" let-option>
                    <div class="option-row">
                      <span class="option-label">{{ option.label }}</span>
                    </div>
                  </ng-template>
                </p-select>
              </td>

              <!-- Stück -->
              <td class="p-2 align-middle">
                <input
                  type="number"
                  formControlName="stueck"
                  class="w-full min-w-[48px] h-10 px-3 py-2 rounded-lg bg-white/8 border border-white/12 text-text-primary text-[0.8125rem] truncate transition-all focus:outline-none focus:border-primary read-only:cursor-not-allowed [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-outer-spin-button]:m-0"
                  min="0"
                  appSelectOnFocus
                />
              </td>

              <!-- Zeit -->
              <td class="p-2 align-middle">
                <button
                  type="button"
                  class="w-full min-w-[48px] h-10 px-3 py-2 rounded-lg bg-white/8 border text-text-primary text-[0.8125rem] truncate transition-all focus:outline-none focus:border-primary read-only:cursor-not-allowed text-left"
                  [ngClass]="isFieldInvalid(row.get('time')) ? 'border-red-500 focus:border-red-500' : 'border-white/12'"
                  [disabled]="!editable()"
                  (click)="openTimePicker(row)"
                >
                  {{ row.get('time')?.value || 'Zeit wählen' }}
                </button>
              </td>

              <!-- Bemerkung -->
              <td class="p-2 align-middle">
                <input
                  type="text"
                  formControlName="bemerkung"
                  class="w-full min-w-[48px] h-10 px-3 py-2 rounded-lg bg-white/8 border border-white/12 text-text-primary text-[0.8125rem] truncate transition-all focus:outline-none focus:border-primary read-only:cursor-not-allowed"
                  appSelectOnFocus
                />
              </td>

              <!-- Actions -->
              <td class="p-2 align-middle">
                <div class="flex items-center gap-1">
                  @if (canRecordFalsePosition()) {
                    <button
                      type="button"
                      class="flex cursor-pointer items-center gap-1 h-10 px-3 rounded-lg text-[0.8125rem] whitespace-nowrap text-text-secondary bg-white/5 border border-white/10 hover:text-amber-400 hover:border-amber-400/40 hover:bg-amber-400/10 transition-all"
                      title="Fehler zu dieser Position erfassen"
                      [disabled]="isSubmitting()"
                      (click)="onRecordFalsePosition(row)"
                    >
                      <span class="material-icons text-base">error</span>
                      Fehler erfassen
                    </button>
                  }
                  <button
                    type="button"
                    class="p-2 rounded-lg text-text-muted hover:text-red-400 hover:bg-white/10 transition-all"
                    title="Position entfernen"
                    [disabled]="isSubmitting()"
                    (click)="removeRow(i)"
                  >
                    <span class="material-icons text-lg">close</span>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
